import {
  BulkAction,
  startDownload,
} from "@punto/frontend-shared/components/bulk-actions";

/**
 * Start the report ZIP downloading the moment its workflow finishes, instead of
 * waiting for a click on the tray's `Descargar ZIP`. By then the ZIP is built and
 * the link is minted, so that click bought nothing.
 *
 * Registered as the `bulk_download_reports` type's `onSettled`, so firing exactly
 * once, and only in the tab that asked, is the shared provider's guarantee. A
 * card left un-dismissed in the tray must not re-download on every reload, and
 * this helper does not attempt to police that itself.
 *
 * The card and its link deliberately stay afterwards: if the fetch fails, or the
 * user dismisses the save dialog, that link is the only way back to the ZIP —
 * which is also why a failed automatic download is left silent.
 */
export const autoDownloadFinishedReport = (action: BulkAction): void => {
  if (!action.downloadUrl) return;

  startDownload(action.downloadUrl).catch(() => undefined);
};
